import React, { useState, useRef } from "react";
import Sidenav from "../../common/Sidenav";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import {
  Button,
  InputLabel,
  Typography,
  TextField,
  Grid,
  Card,
  Divider,
  Snackbar,
  Alert,
  useMediaQuery,
} from "@mui/material";

import Header from "../../common/Header";
import NavigatedComponent from "../NavigatedComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { DropzoneArea } from "mui-file-dropzone";
import { apiList, invokeApi } from "../../../services/apiServices";
import { config } from "../../../config/config";
import { useCookies } from "react-cookie";
import IconSidenav from "../../common/IconSidenav";

const AddPeople = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [cookies] = useCookies();
  const [profileImage, setProfileImage] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const isMobileScreen = useMediaQuery(
    "(min-width:360px) and (max-width:500px)"
  );
  const [people, setPeople] = useState({
    name: "",
    position: "",
    email: "",
    qualifications: "",
    description: "",
    fullProfile1: "",
    fullProfile2: "",
    fullProfile3: "",
    ogUrl: "",
    category: "",
    categoryUrl: "",
    imageUrl: "",
    createdBy: "admin",
  });
  const [showSideNav, setShowSideNav] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const toggleSideNav = () => {
    setShowSideNav(!showSideNav);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setPeople((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleProfileImage = (files) => {
    if (files && files.length > 0) {
      setProfileImage(files[0]);
    } else {
      setProfileImage(null);
    }
  };

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleAddCollegeProfileImage = async () => {
    if (!profileImage) {
      showSnackbar("Please select a profile image first.", "warning");
      return "";
    }

    const formData = new FormData();
    formData.append("profile", profileImage);

    try {
      const response = await fetch("https://api.reef.org.in/addProfileImage", {
        method: "POST",
        body: formData,
      });

      if (response?.status >= 200 && response?.status < 300) {
        const responseData = await response.json();
        if (responseData.imageUrl) {
          setPeople((prev) => ({ ...prev, imageUrl: responseData.imageUrl }));
          return responseData.imageUrl;
        } else {
          showSnackbar("Image upload did not return URL", "error");
          return "";
        }
      } else {
        showSnackbar("Failed to add profile image", "error");
        return "";
      }
    } catch (error) {
      showSnackbar("Something went wrong. Please try again later.", "error");
      return "";
    }
  };

  const stripPTags = (text) => {
  if (!text) return "";
  return text.replace(/<\/?p>/gi, '').trim();
};


  const handleAddPeople = async (imageUrl) => {
    const params = {
      ...people,
      imageUrl,
       fullProfile1: stripPTags(people.fullProfile1),
    fullProfile2: stripPTags(people.fullProfile2),
    fullProfile3: stripPTags(people.fullProfile3),
    };

    try {
      const response = await invokeApi(
        config.getMyCollege + apiList.addPerson,
        params,
        cookies
      );

      if (response?.status >= 200 && response?.status < 300) {
        if (response.data.responseCode === "200") {
          showSnackbar("Person added successfully", "success");
          navigate("/people-manager/people-list");
        } else if (response.data.responseCode === "400") {
          showSnackbar(response.data.message, "error");
        }
      }
    } catch (error) {
      console.error("Error during adding person:", error);
      showSnackbar("Something went wrong. Please try again later!!", "error");
    }
  };
  

  const handlePeopleSubmit = async (event) => {
    event.preventDefault();
    
    if (isSubmitting) return; // Prevent multiple submissions
    
    setIsSubmitting(true);

    // Validate required fields
    if (!people.name || !people.position || !people.email) {
      showSnackbar("Please fill all required fields", "warning");
      setIsSubmitting(false);
      return;
    }

    // Upload profile image first and get URL
    const imageUrl = await handleAddCollegeProfileImage();

    if (!imageUrl) {
      // Image upload failed, abort submission
      setIsSubmitting(false);
      return;
    }

    // Call handleAddPeople with the imageUrl
    await handleAddPeople(imageUrl);
    setIsSubmitting(false);
  };

  return (
    <>
      <Grid sx={{ display: "flex" }}>
        {isMobileScreen ? (
          <IconSidenav />
        ) : showSideNav ? (
          <IconSidenav />
        ) : (
          <Sidenav />
        )}
        <Grid component="main" sx={{ width: "100%", px: 1 }}>
          <Header toggleSideNav={toggleSideNav} />
          <Grid sx={{ py: 1 }}>
            <NavigatedComponent pathname={location.pathname} />
            <Grid sx={{ width: "100%", px: isMobileScreen ? 1 : 5 }}>
              <Card elevation={1} sx={{ my: 5 }}>
                <Grid sx={{ py: isMobileScreen ? 2 : 2 }}>
                  <Typography
                    sx={{
                      mb: 2,
                      mx: isMobileScreen ? 2 : 8,
                      textAlign: "left",
                      fontSize: isMobileScreen ? 14 : 18,
                      fontWeight: 600,
                      textTransform: "uppercase",
                    }}
                  >
                    Create New People
                  </Typography>
                  <Divider sx={{ mb: 3 }} />

                  <form onSubmit={handlePeopleSubmit}>
                    <Grid
                      container
                      md={12}
                      xs={12}
                      sx={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-around",
                        my: 2,
                      }}
                    >
                      {/* Form Fields */}
                      {[
                        { label: "Name *", name: "name", required: true },
                        {
                          label: "Position *",
                          name: "position",
                          required: true,
                        },
                        {
                          label: "Email *",
                          name: "email",
                          required: true,
                          type: "email",
                        },
                        { label: "Qualifications", name: "qualifications" },
                        {
                          label: "Description",
                          name: "description",
                          multiline: true,
                        },
                        {
                          label: "Full Profile 1",
                          name: "fullProfile1",
                          multiline: true,
                        },
                        {
                          label: "Full Profile 2",
                          name: "fullProfile2",
                          multiline: true,
                        },
                        {
                          label: "Full Profile 3",
                          name: "fullProfile3",
                          multiline: true,
                        },
                        { label: "OG URL", name: "ogUrl" },
                        { label: "Category", name: "category" },
                        { label: "Category URL", name: "categoryUrl" },
                      ].map((field, index) => (
                        <Grid key={index} item md={11} xs={11} sx={{ my: 2 }}>
                          <InputLabel
                            sx={{
                              fontWeight: "bold",
                              my: 1,
                              fontSize: isMobileScreen ? 12 : 15,
                            }}
                          >
                            {field.label}
                          </InputLabel>
                          <TextField
                            placeholder={`Enter ${field.label
                              .replace("*", "")
                              .trim()}`}
                            fullWidth
                            name={field.name}
                            type={field.type || "text"}
                            value={people[field.name]}
                            onChange={handleInputChange}
                            multiline={field.multiline || false}
                            rows={field.multiline ? 3 : 1}
                            inputProps={{
                              style: {
                                height: !field.multiline
                                  ? isMobileScreen
                                    ? "3px"
                                    : "8px"
                                  : undefined,
                                fontSize: isMobileScreen ? 12 : 14,
                              },
                            }}
                            required={field.required || false}
                          />
                        </Grid>
                      ))}

                      {/* Profile Image Upload */}
                      <Grid
                        container
                        md={12}
                        sx={{ justifyContent: "space-around", my: 5 }}
                      >
                        <Grid item md={2} xs={11}>
                          <InputLabel
                            sx={{
                              fontWeight: "bold",
                              my: 1,
                              fontSize: isMobileScreen ? 12 : 15,
                            }}
                          >
                            Profile Image *
                          </InputLabel>
                          <Grid
                            sx={{
                              my: 4,
                              ".MuiBox-root ": {
                                bgcolor: "#f0f8ff",
                                borderColor: "#1d1a57",
                                minHeight: 0,
                                my: 1,
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <DropzoneArea
                              filesLimit={1}
                              onChange={handleProfileImage}
                              acceptedFiles={["image/jpeg", "image/png"]}
                              maxFileSize={5000000}
                              showPreviews={true}
                              showAlerts={false}
                              showPreviewsInDropzone={false}
                              showFileNames={false}
                              Icon={(props) => (
                                <CloudUploadIcon
                                  style={{
                                    color: "#1d1a57",
                                    width: 35,
                                    height: 35,
                                  }}
                                  {...props}
                                />
                              )}
                              dropzoneText={
                                <Typography
                                  sx={{
                                    color: "#1d1a57",
                                    fontWeight: 600,
                                    fontSize: 16,
                                  }}
                                >
                                  Upload / Drag files
                                </Typography>
                              }
                              previewText="Selected Profile Image:"
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    {/* Submit Button */}
                    <Divider sx={{ mb: 1 }} />
                    <Grid container sx={{ justifyContent: "center" }}>
                      <Button
                        type="submit"
                        disabled={!profileImage || isSubmitting}
                        sx={{
                          my: 2,
                          px: 2,
                          fontSize: 12,
                          background: "#1d1a57",
                          color: "#FFF",
                          fontWeight: 600,
                          "&:hover": {
                            background: "#1d1a57",
                            color: "#FFF",
                          },
                          "&:disabled": {
                            background: "#cccccc",
                            color: "#666666",
                          },
                        }}
                      >
                        <DriveFolderUploadIcon />
                        &nbsp; {isSubmitting ? "Publishing..." : "Publish"}
                      </Button>
                    </Grid>
                  </form>
                </Grid>
              </Card>

              {/* Snackbar for alerts */}
              <Snackbar
                open={openSnackbar}
                autoHideDuration={2000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
              >
                <Alert
                  onClose={handleCloseSnackbar}
                  severity={snackbarSeverity}
                >
                  {snackbarMessage}
                </Alert>
              </Snackbar>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default AddPeople;